import { useEffect, useState } from "react";

import "./BiorSwap.css";
import Footer from "./Components/Footer";
import { SwapWalkthrough } from "./Components/SwapWalkthrough";
import "./Components/SwapWalkthrough.css";
import { BybTokenSection } from "./Components/BybTokenSection";

import swapIcon from "../assets/icons/vuesax/outline/arrow-swap.svg";
import linkIcon from "../assets/icons/vuesax/outline/link.svg";
import statusUpIcon from "../assets/icons/vuesax/outline/status-up.svg";
import aiIcon from "../assets/icons/vuesax/outline/AI Icon.svg";
import mayaIcon from "../assets/Maya.svg";
import chainflipIcon from "../assets/chainflip.svg";
import ProofIcon from "../assets/PROOF-solid-white 1.svg";
import thorchainBrand from "../assets/thorchain.svg";

import bitcoin from "../assets/chains/Bitcoin.png";
import bitcoinCash from "../assets/chains/Bitcoin-cash.png";
import solana from "../assets/chains/solana.png";
import thorchain from "../assets/chains/thorchain.png";
import mayaChain from "../assets/chains/maya-chain.png";
import cosmos from "../assets/chains/Cosmos.png";
import eth from "../assets/chains/Ethereum.png";
import bsc from "../assets/chains/bsc.png";
import polygon from "../assets/chains/polygon.png";
import arbitrum from "../assets/chains/Arbitrum.png";
import base from "../assets/chains/base.png";
import avalanche from "../assets/chains/Avalanche.png";
import litecoin from "../assets/chains/Litecoin.png";
import optimism from "../assets/chains/Optimism.png";
import dogecoin from "../assets/chains/dogecoin.png";

import zkSyncLogo from "../assets/chains/biorswap chains/zkSync.png";
import starknetLogo from "../assets/chains/biorswap chains/starknet-token-strk-logo.svg";
import osmosisLogo from "../assets/chains/biorswap chains/osmosis-osmo-logo.svg";
import injectiveLogo from "../assets/chains/biorswap chains/injective-inj-logo.svg";
import metisLogo from "../assets/chains/biorswap chains/metisdao-metis-logo.svg";
import celoLogo from "../assets/chains/biorswap chains/celo-celo-logo.svg";
import blastLogo from "../assets/chains/biorswap chains/Blast.png";
import modeLogo from "../assets/chains/biorswap chains/mode.png";
import scrollLogo from "../assets/chains/biorswap chains/scroll_io_logo.jpeg";
import lineaLogo from "../assets/chains/biorswap chains/linea1680021297845.png";
import moonriverLogo from "../assets/chains/biorswap chains/Moonriver-MOVR.svg";
import cronosLogo from "../assets/chains/biorswap chains/cronos-cro-logo.svg";
import bobaLogo from "../assets/chains/biorswap chains/boba-network-logo.svg";
import auroraLogo from "../assets/chains/biorswap chains/Aurora-logo.jpg";

const HERO_STATS = [
  { value: "30+",    label: "Integrated chains" },
  { value: "120+",   label: "DEXs & bridges" },
  { value: "0.4%",   label: "Aggregator fee" },
  { value: "1-click",label: "Cross-chain swap" },
];

/* Full supported-chains list. Chains without a local logo use a placeholder
 * disc with the chain's accent colour + 1-3 letter abbreviation. Drop a real
 * PNG/SVG into src/assets/chains/ and swap the `logo` field to upgrade. */
const ALL_CHAINS = [
  { name: "Bitcoin",       logo: bitcoin },
  { name: "Ethereum",      logo: eth },
  { name: "Avalanche",     logo: avalanche },
  { name: "Solana",        logo: solana },
  { name: "Litecoin",      logo: litecoin },
  { name: "BNB Chain",     logo: bsc },
  { name: "zkSync",        logo: zkSyncLogo },
  { name: "Starknet",      logo: starknetLogo },
  { name: "Cosmos",        logo: cosmos },
  { name: "THORChain",     logo: thorchain },
  { name: "Maya",          logo: mayaChain },
  { name: "Optimism",      logo: optimism },
  { name: "Arbitrum",      logo: arbitrum },
  { name: "Osmosis",       logo: osmosisLogo },
  { name: "Injective",     logo: injectiveLogo },
  { name: "Metis",         logo: metisLogo },
  { name: "Celo",          logo: celoLogo },
  { name: "Blast",         logo: blastLogo },
  { name: "Mode",          logo: modeLogo },
  { name: "Scroll",        logo: scrollLogo },
  { name: "Polygon",       logo: polygon },
  { name: "zkEVM",         logo: polygon },
  { name: "Linea",         logo: lineaLogo },
  { name: "Base",          logo: base },
  { name: "Dogecoin",      logo: dogecoin },
  { name: "Moonriver",     logo: moonriverLogo },
  { name: "Cronos",        logo: cronosLogo },
  { name: "Bitcoin Cash",  logo: bitcoinCash },
  { name: "Boba",          logo: bobaLogo },
  { name: "Aurora",        logo: auroraLogo, whiteBg: true },
];

/* Curated subset used in the animated orbit around the hero.
 * We pick the most visually recognisable logos so the orbit stays crisp. */
const ORBIT_CHAINS = [
  ALL_CHAINS[0],  // Bitcoin
  ALL_CHAINS[1],  // Ethereum
  ALL_CHAINS[3],  // Solana
  ALL_CHAINS[9],  // THORChain
  ALL_CHAINS[10], // Maya
  ALL_CHAINS[5],  // BNB
  ALL_CHAINS[20], // Polygon
  ALL_CHAINS[12], // Arbitrum
  ALL_CHAINS[23], // Base
  ALL_CHAINS[2],  // Avalanche
  ALL_CHAINS[8],  // Cosmos
  ALL_CHAINS[24], // Dogecoin
  ALL_CHAINS[11], // Optimism
  ALL_CHAINS[4],  // Litecoin
];

const CAPABILITIES = [
  {
    icon: swapIcon,
    eyebrow: "Smart routing",
    title: "Best rate, every route.",
    desc:
      "BiorSwap aggregates DEXs, bridges and cross-chain protocols to find the most efficient path for every swap — no stops, no wrapping, no wasted gas.",
  },
  {
    icon: linkIcon,
    eyebrow: "One aggregator",
    title: "30+ chains, one interface.",
    desc:
      "Move assets across EVM, Cosmos, UTXO and Layer 1 networks from a single screen. Connect any wallet and swap without juggling bridges.",
  },
  {
    icon: statusUpIcon,
    eyebrow: "Transparent pricing",
    title: "Fees you can read at a glance.",
    desc:
      "Flat 0.4% aggregator fee on every route. Real-time quotes, gas estimates and slippage surfaced before you sign.",
  },
  {
    icon: aiIcon,
    eyebrow: "Built for builders",
    title: "API & widget for your dApp.",
    desc:
      "Drop cross-chain liquidity into your product with our SDK or no-code widget — the same engine powering BiorVault.",
    comingSoon: true,
  },
];

const WORKFLOW_STEPS = [
  {
    step: "01",
    title: "Pick your pair",
    detail:
      "Choose any asset on any supported chain. BiorSwap scans 120+ venues in real time and surfaces the best route.",
  },
  {
    step: "02",
    title: "Review the route",
    detail:
      "See the hops, bridges and DEXs chosen for your trade, with transparent fees and an ETA before you confirm.",
  },
  {
    step: "03",
    title: "Swap in one click",
    detail:
      "Sign once from your connected wallet. BiorSwap orchestrates the route end-to-end and settles on the destination chain.",
  },
];

const PARTNERS = [
  { src: mayaIcon, alt: "Maya Protocol", href: "https://www.mayaprotocol.com/", imgClass: "h-10 w-auto", meta: "Protocol layer" },
  { src: chainflipIcon, alt: "Chainflip", href: "https://chainflip.io/", imgClass: "h-10 w-auto", meta: "Protocol layer" },
  { src: thorchainBrand, alt: "THORChain", href: "https://thorchain.org/", imgClass: "h-10 w-auto partner-card__logo--thorchain", meta: "Protocol layer" },
  { src: ProofIcon, alt: "Proof", href: "https://proofplatform.io/", imgClass: "h-10 w-auto", meta: "Incubator" },
];

function ChainGlyph({ chain, small = false }) {
  if (chain.logo) {
    return (
      <img
        src={chain.logo}
        alt=""
        aria-hidden="true"
        className={chain.whiteBg ? "biorswap-chain-img--white" : undefined}
      />
    );
  }
  return (
    <span
      className={`biorswap-glyph ${small ? "biorswap-glyph--small" : ""}`}
      style={{ "--glyph-color": chain.color || "#7B7CFF" }}
    >
      {chain.abbr || chain.name.slice(0, 2)}
    </span>
  );
}

function OrbitChains() {
  const outer = ORBIT_CHAINS.slice(0, 8);
  const inner = ORBIT_CHAINS.slice(8);
  return (
    <div className="biorswap-orbit" aria-hidden="true">
      <div className="biorswap-orbit__ring biorswap-orbit__ring--outer">
        {outer.map((chain, i) => (
          <span
            key={`o-${chain.name}`}
            className="biorswap-orbit__item"
            style={{ "--i": i, "--n": outer.length }}
          >
            <ChainGlyph chain={chain} />
          </span>
        ))}
      </div>
      <div className="biorswap-orbit__ring biorswap-orbit__ring--inner">
        {inner.map((chain, i) => (
          <span
            key={`i-${chain.name}`}
            className="biorswap-orbit__item biorswap-orbit__item--small"
            style={{ "--i": i, "--n": inner.length }}
          >
            <ChainGlyph chain={chain} small />
          </span>
        ))}
      </div>
    </div>
  );
}

export const BiorSwap = () => {
  const [ready, setReady] = useState(false);
  const [showSoon, setShowSoon] = useState(false);
  useEffect(() => { setReady(true); }, []);

  const revealComingSoon = () => {
    setShowSoon(true);
    window.setTimeout(() => setShowSoon(false), 2200);
  };

  return (
    <div className="biorswap-shell">
      <div className="biorswap-bg" aria-hidden="true">
        <div className="biorswap-bg__grid" />
        <div className="biorswap-bg__glow biorswap-bg__glow--left" />
        <div className="biorswap-bg__glow biorswap-bg__glow--right" />
        <div className="biorswap-bg__beam" />
      </div>

      {/* ── Hero ─────────────────────────────────────── */}
      <section
        className={`biorswap-hero ${ready ? "is-ready" : ""}`}
        style={{ paddingTop: "calc(7rem + var(--safe-area-top))" }}
      >
        <div className="biorswap-hero__stage">
          <OrbitChains />
        </div>

        <div className="biorswap-hero__content">
          <h1 className="biorswap-hero__title font-syne">
            Swap <span className="biorswap-grad">anything</span>,
            <br />
            anywhere on-chain.
          </h1>

          <p className="biorswap-hero__sub font-dm">
            The universal cross-chain aggregator from BiorLabs. BiorSwap routes every trade across
            30+ chains and 120+ DEXs and bridges in a single, signature-light flow — powered by the
            same engine that drives BiorVault.
          </p>

          <div className="biorswap-hero__ctas">
            <div className="biorswap-cta-wrap">
              <button
                type="button"
                onClick={revealComingSoon}
                onMouseEnter={() => setShowSoon(true)}
                onMouseLeave={() => setShowSoon(false)}
                onFocus={() => setShowSoon(true)}
                onBlur={() => setShowSoon(false)}
                className="biorswap-cta biorswap-cta--primary"
                aria-label="Use BiorSwap — coming soon"
                aria-describedby={showSoon ? "biorswap-cta-soon" : undefined}
                data-testid="biorswap-launch-app-btn"
              >
                <span>Use BiorSwap</span>
                <span className="biorswap-cta__arrow" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5l5 5-5 5" />
                  </svg>
                </span>
              </button>

              {showSoon ? (
                <div
                  id="biorswap-cta-soon"
                  role="status"
                  className="biorswap-cta-soon"
                >
                  <span className="biorswap-cta-soon__accent">Coming soon</span>
                  <span className="biorswap-cta-soon__muted"> — we'll announce it</span>
                </div>
              ) : null}
            </div>
          </div>

          {/* Animated cross-chain swap walkthrough */}
          <div className="biorswap-hero__walk">
            <SwapWalkthrough />
          </div>

          <div className="biorswap-hero__stats" data-testid="biorswap-hero-stats">
            {HERO_STATS.map((s) => (
              <div key={s.label} className="biorswap-stat">
                <span className="biorswap-stat__value font-syne">{s.value}</span>
                <span className="biorswap-stat__label font-dm">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Capabilities ─────────────────────────────── */}
      <section className="biorswap-section" data-testid="biorswap-capabilities">
        <div className="biorswap-container">
          <div className="biorswap-section__head">
            <span className="biorswap-eyebrow font-dm">Why BiorSwap</span>
            <h2 className="biorswap-section__title font-syne">
              A cross-chain engine built for <span className="biorswap-grad">precision</span>.
            </h2>
            <p className="biorswap-section__lead font-dm">
              Every trade is a routing problem. BiorSwap solves it with smart path-finding,
              transparent fees and one-click execution — even across wildly different networks.
            </p>
          </div>

          <div className="biorswap-cap-grid">
            {CAPABILITIES.map((c) => (
              <div key={c.title} className={`biorswap-cap ${c.comingSoon ? "biorswap-cap--soon" : ""}`}>
                {c.comingSoon ? (
                  <span className="biorswap-cap__soon font-dm" data-testid="biorswap-cap-soon">
                    <span className="biorswap-cap__soon-dot" aria-hidden="true" />
                    On the roadmap
                  </span>
                ) : null}
                <div className="biorswap-cap__icon">
                  <img src={c.icon} alt="" aria-hidden="true" />
                </div>
                <div className="biorswap-cap__eyebrow font-dm">{c.eyebrow}</div>
                <h3 className="biorswap-cap__title font-syne">{c.title}</h3>
                <p className="biorswap-cap__desc font-dm">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How it works ─────────────────────────────── */}
      <section className="biorswap-section" data-testid="biorswap-howitworks">
        <div className="biorswap-container">
          <div className="biorswap-section__head">
            <span className="biorswap-eyebrow font-dm">How it works</span>
            <h2 className="biorswap-section__title font-syne">
              Three steps. One signature.
            </h2>
          </div>

          <div className="biorswap-flow">
            {WORKFLOW_STEPS.map((s) => (
              <div key={s.step} className="biorswap-flow__card">
                <div className="biorswap-flow__num font-syne">{s.step}</div>
                <h3 className="biorswap-flow__title font-syne">{s.title}</h3>
                <p className="biorswap-flow__detail font-dm">{s.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Coverage / integrations ─────────────────── */}
      <section className="biorswap-section" data-testid="biorswap-coverage">
        <div className="biorswap-container biorswap-coverage">
          <div className="biorswap-coverage__copy">
            <span className="biorswap-eyebrow font-dm">Coverage</span>
            <h2 className="biorswap-section__title font-syne">
              <span className="biorswap-grad">30+</span> chains.
              <br />
              <span className="biorswap-grad">120+</span> protocols.
              <br />
              One flow.
            </h2>
            <p className="biorswap-section__lead font-dm">
              BiorSwap speaks UTXO, EVM, Cosmos and bespoke L1s natively — the aggregation layer
              that powers BiorVault is now available on the open web.
            </p>
          </div>
          <div className="biorswap-coverage__chains" data-testid="biorswap-coverage-chains">
            {ALL_CHAINS.map((chain) => (
              <div key={chain.name} className="biorswap-chain-chip" title={chain.name}>
                <ChainGlyph chain={chain} small />
                <span className="font-dm">{chain.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Partners (identical markup to BiorVault's "Built with industry
           leaders" so both landings render the same section). */}
      <section className="deferred-section relative px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14" data-testid="biorswap-partners">
        <div className="mx-auto max-w-7xl">
          <div className="partner-shell">
            <div className="mx-auto max-w-3xl text-center">
              <h2
                className="mt-6 font-syne text-white"
                style={{ fontSize: "clamp(1.8rem, 3.6vw, 2.9rem)", lineHeight: "1.06", fontWeight: 700 }}
              >
                Built with{" "}
                <span className="hero-alive-accent">industry leaders.</span>
              </h2>
            </div>

            <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
              {PARTNERS.map((partner) => (
                <a
                  key={partner.alt}
                  href={partner.href}
                  target="_blank"
                  rel="noreferrer"
                  className="partner-card"
                  aria-label={partner.alt}
                >
                  <img
                    src={partner.src}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    decoding="async"
                    className={`w-auto object-contain brightness-0 invert opacity-70 ${partner.imgClass}`}
                  />
                  <div className="partner-card__meta">{partner.meta}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <BybTokenSection />

      <Footer />
    </div>
  );
};

export default BiorSwap;
